import { ShopkeeperLayoutComponent } from './../../../shared/components/layouts/shopkeeper-layout/shopkeeper-layout.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { SessionGuard } from '@app-shared/guards/session-auth.guard';
import { RoleGuard } from '@app-shared/guards/roles.guard';
import { Role } from '@app/store/session/session.store';

const routes: Routes = [
  {
    path: '',
    component: ShopkeeperLayoutComponent,
    children: [
      {
        path: 'arrematar',
        loadChildren: () => import('./cast-off/cast-off.module').then(m => m.CastOffModule),
        data: {
          roles: [
            Role.ADMIN,
            Role.DEALER,
            Role.OEM_DEALER_MANAGER
          ],
        },
      },
      {
        path: 'vender',
        loadChildren: () => import('./oem-dealer/oem-dealer.module').then(m => m.OemDealerModule),
        canActivate: [SessionGuard, RoleGuard],
        data: {
          roles: [
            Role.ADMIN,
            Role.DEALER,
            Role.OEM_DEALER_MANAGER,
            Role.DESK_SELL,
            Role.REGISTERER,
            Role.LOCATION_MANAGER
          ],
        },
      },
      {
        path: 'cotacao-rapida',
        loadChildren: () => import('./fast-quote/fast-quote.module').then(m => m.FastQuoteModule),
        canActivate: [SessionGuard, RoleGuard],
        data: {
          roles: [
            Role.ADMIN,
            Role.DEALER,
            Role.OEM_DEALER_MANAGER
          ],
        },
      },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ShopkeeperRoutingModule { }
